import { FC, useState } from 'react';
import { Box, Button, Popover, Typography } from '@mui/material';
import { LoadingButton as LB } from '@mui/lab';
import { LoadingButtonProps } from './types';

const LoadingButton: FC<LoadingButtonProps> = ({ confirmText, onClick, ...props }) => {
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

	const handleClick = (event: React.MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget);
	const handleClose = () => setAnchorEl(null);
	const handleConfirm = (e) => {
		onClick?.(e);
		handleClose();
	};

	const open = Boolean(anchorEl);

	return (
		<>
			<LB {...props} onClick={handleClick} />
			{confirmText && (
				<Popover
					open={open}
					anchorEl={anchorEl}
					onClose={handleClose}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
					transformOrigin={{ vertical: 'top', horizontal: 'center' }}
				>
					<Box p={2} maxWidth='200px'>
						<Typography>{confirmText}</Typography>
						<Box mt={1} display='flex' justifyContent='space-between'>
							<Button size='small' onClick={handleClose}>
								Cancel
							</Button>
							<Button color='error' size='small' onClick={handleConfirm}>
								Confirm
							</Button>
						</Box>
					</Box>
				</Popover>
			)}
		</>
	);
};

export default LoadingButton;
